import { RestClient } from '@libs/rest-client';
import type { SsoStatus, UserState } from '../../../types';
import type { AdminLoginCredentials, LoginCredentials } from '../models';

const LOGIN_URL = '/login';
const ADMIN_LOGIN_URL = `/root${LOGIN_URL}`;
const SANDBOX_LOGIN_URL = `/sandbox${LOGIN_URL}`;

async function signIn(credentials: LoginCredentials, isSandbox: boolean | undefined) {
  return await RestClient.auth.post<UserState>(isSandbox ? SANDBOX_LOGIN_URL : LOGIN_URL, credentials);
}

async function adminSignIn(credentials: AdminLoginCredentials) {
  return await RestClient.auth.post(ADMIN_LOGIN_URL, credentials);
}

async function checkSandboxExistence(organizationName: string) {
  return await RestClient.fa.get(`/sandbox/find-resource?organizationName=${organizationName}`);
}

async function fetchUserPoolInfo(organizationId: string) {
  return await RestClient.auth.get<{
    cognitoDomain: string;
    clientId: string;
    idpName: string;
  }>(`/sso/user-pool-info?organizationId=${organizationId}`);
}

async function fetchTokensBy(organizationId: string, code: string) {
  return await RestClient.auth.post<{ region: string }>('/sso/token', { organizationId, code });
}

async function fetchSsoStatus(organizationId: string) {
  const res = await RestClient.auth.get<{
    organizationName: string;
    ssoStatus: SsoStatus;
  }>(`/sso-setting/${organizationId}`);
  return {
    ...res,
    organizationId,
  };
}

export { adminSignIn, checkSandboxExistence, fetchSsoStatus, fetchTokensBy, fetchUserPoolInfo, signIn };
